import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import API_URLS from "../config/apiConfig";
import swal from 'sweetalert';
import { ClipLoader } from "react-spinners";
import InlineEditorComponent from "../components/InlineEditorComponent";

const ChapterForm = ({ selectedChapter, onUpdate }) => {
  const authToken = localStorage.getItem("token");
 // const navigate = useNavigate();
  const [removeExistingPhoto, setRemoveExistingPhoto] = useState(false);
  const [errors, setErrors] = useState({});   
  const [loading, setLoading] = useState(false);
  const [photo, setPhoto] = useState(null);
 
  const [chapterData, setChapterData] = useState({ ...selectedChapter });
 // setimageURL(chapterData.image_thumb_url);
 
  
  //console.log(chapterData);
  const handleInputChange = (e) => {   
    const { name, value } = e.target;
    setChapterData({ ...chapterData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };
  const handleDescriptionChange = (value) => {
    setChapterData((prevData) => ({
        ...prevData,
        description: value, // Update description
    }));
};
const handleMediaChange = (e) => {
  const selectedValue = e.target.value;
 
 
  setChapterData((prevData) => ({
      ...prevData,
      media_type: selectedValue,
  }));
};
const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
     setPhoto(URL.createObjectURL(file));
     setChapterData({ ...chapterData, image: URL.createObjectURL(file) });
     setRemoveExistingPhoto(false);
  }
};

const handleRemoveImage = () => {
  setPhoto(null); // Clear preview
  chapterData.image_thumb_url=null;
  setChapterData((prevData) => ({
    ...prevData,
    photo: null,
  }));
  setRemoveExistingPhoto(true); // Mark existing image for removal
};
  const validate = () => {
    const newErrors = {};
   
   if (!chapterData.chapter_name.trim()){ newErrors.chapter_name = "Please enter chapter name";}
   return newErrors;
   };
  const handleFormSubmit = async(e) => {
    e.preventDefault();
   // onSubmit(chapterData);

   const validationErrors = validate();
   if (Object.keys(validationErrors).length > 0) {
     setErrors(validationErrors);
     return;
   }
   setLoading(true);
   try {
   const data = new FormData();
   data.append('course_id', chapterData.course_id);
   data.append('chapter_name', chapterData.chapter_name);
   data.append('description', chapterData.description);
   data.append('media_type', chapterData.media_type);
   data.append('id', chapterData.id);
   data.append('remove_photo', removeExistingPhoto ? 1 : 0); 
   if(photo){
     const fileInput = document.querySelector('input[type="file"]');
     data.append('photo', fileInput.files[0]);
   }
   const response = await axios.post(API_URLS.CHAPTER_SAVE, data,{
       headers: {
         Authorization: `Bearer ${authToken}`,
         'Content-Type': 'multipart/form-data'
       },
     });
     if(response.data.success==1){
     swal("Success", response.data.message, "success").then(() => {
       //navigate(`/manager/course-chapter?course_id=${chapterData.course_id}`); // Redirect to the target page
       //  window.location.reload();
       onUpdate();
     });
    
     }else{
     swal("Error", response.data.message, "error");  
     }
     
    // console.log(response.data); // Handle response
   } catch (error) {
     swal("Error", "Please try again.", "error");  
     console.error("Error:", error.response?.data || error.message);
   }finally {
     setLoading(false); 
   }
 };

 return (
  <>  {loading && (
                      <div className="loader-overlay">
                          <ClipLoader color="#08A9E6" loading={loading} size={50} />
                      </div>
                  )}
    <div className="col-md-8">
      <form onSubmit={handleFormSubmit}>
        <h3>Edit Chapter</h3>
        <div className="form-group">
          <label>Chapter Name</label>
          <input
            type="text"
            name="chapter_name"
            className="form-control"
            value={chapterData.chapter_name || ""}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>Description</label>
         <InlineEditorComponent name="description"
                    value={chapterData.description}
                    onChange={handleDescriptionChange} 
                /> 
          
          {errors.description && <p style={{ color: "red" }}>{errors.description}</p>}
                                  
        </div>
        <div className="form-group mt-2">
        <label>Upload Media</label>
        <div className="ms-2 form-check form-check-inline">
          <input className="form-check-input" type="radio" name="media_type" id="inlineRadio1" value="Image" checked={chapterData.media_type === "Image"} onChange={handleMediaChange} />
          <label className="form-check-label" htmlFor="inlineRadio1">Image</label>
         </div>
         <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="media_type" id="inlineRadio3" value="Video" checked={chapterData.media_type === "Video"} onChange={handleMediaChange}/>
          <label className="form-check-label" htmlFor="inlineRadio3">Video</label>
        </div>
          <br/>
          <input
                    type="file"                  
                    onChange={handleImageChange}
                />
                {photo && (
                    <div>
                       
                       <Link href={photo}  target="_blank" >View Media</Link>
                        <span onClick={handleRemoveImage} title="Remove Image"><i className="fa fa-trash ms-3"></i></span>
                    </div>
                )}
                 {chapterData.image_url && !photo && (
                    <div>
                       
                       <Link to={chapterData.image_url}  target="_blank" >View Media</Link>
                        <span onClick={handleRemoveImage} title="Remove Media"><i className="fa fa-trash ms-3"></i></span>
                    </div>
                )}
                
        </div>
         <div className="row">
            <div className="col-lg-12 col-md-12 mt-2 mb-5">
            <button type="submit" className="default-btn" disabled={loading}>
             {loading ? "Submitting..." : "Submit"}
             </button>                                                                          
              </div>
         </div>
      </form>
    </div>
    </>  );
};

export default ChapterForm;
